import { View } from 'components/View/View'
import * as React from 'react'
import { RouteComponentProps } from 'react-router'
import Styles from './HomePage.module.css'
import RFB from 'modules/novnc/core/rfb'
import { APIRequest } from 'lynxapirequests'
import * as qs from 'query-string'
import { ConfigState } from 'store/config'
import { connect } from 'react-redux'
import { ProfileState } from 'store/profile'
import { ApplicationState } from 'store'
import { ChangeEvent, RefObject } from 'react'
import { generateCode, ChannelState } from 'store/channel'
import { subscribe, wsConnect, wsMessage } from 'store/messaging'

const md5 = require('md5')

interface vncProps extends RouteComponentProps {
	config: ConfigState
	channel: ChannelState
	generateCode: (fileId: string) => void
	wsMessage: typeof wsMessage
	subscribe: (channelId: string) => Promise<void>
	wsConnect: (server: string) => void
}

interface vncState {
	userId: string
	fileName: string
	rfb: RFB | undefined
	connected: boolean
}

class Page extends React.Component<vncProps, vncState> {
	private screenRef: RefObject<HTMLDivElement>
	private connectionTries: number
	private connected: boolean
	private query = qs.parse(this.props.location.search)

	constructor(props: vncProps) {
		super(props)
		this.screenRef = React.createRef<HTMLDivElement>()
		this.connectionTries = 0
		this.connected = false

		this.state = {
			userId: '',
			fileName: '',
			rfb: undefined,
			connected: false,
		}
	}

	async componentDidMount() {
		if (!this.query.file && !this.query.name && !this.query.userId) {
			return <h1>Something went wrong!</h1>
		}

		const { fileName, userId } = this.query
		if (typeof fileName !== 'string' || typeof userId !== 'string') {
			console.error('Incorrect types in query params.')
			return
		}
		const result = await APIRequest.Translator.apply(fileName, userId)
		await this.makeVNCConnection(fileName, userId, result.domain)
	}

	async makeVNCConnection(fileName: string, userId: string, url: string) {
		try {
			this.connectionTries++
			const rfb: RFB = new RFB(this.screenRef.current, `wss://${url}`, {
				credentials: { password: 'password' },
			})
			rfb.scaleViewport = true
			rfb.clipViewport = true
			rfb.resizeSession = true
			rfb.viewOnly = false
			rfb.showDotCursor = true

			rfb.addEventListener('disconnect', async () => {
				console.log('Not Connected')
				this.setState({
					connected: false,
				})
				setTimeout(() => {
					console.log('Retry...')
					this.connectionTries++
					this.makeVNCConnection(fileName, userId, url)
				}, 3000)
			})

			rfb.addEventListener('connect', async () => {
				console.log('Connected')
				this.setState({
					rfb,
					connected: true,
				})
			})
		} catch (err) {
			console.error(err)
		}
	}

	deletePod = async () => {
		const { fileName } = this.query
		console.log(fileName)
		await APIRequest.Translator.delete(fileName as string)
		window.close()
		return true
	}

	render(): React.ReactNode {
		return (
			<div className={Styles.container}>
				<div className={Styles.body}>
					{!this.state.connected && (
						<div className={Styles.loadingContainer}>
							<div className={Styles.animateFlicker}>
								<img
									alt="Lynx Logo"
									src="/lynx-whiteboard-logo.svg"
								/>
								<p>Loading...</p>
							</div>
						</div>
					)}
					{this.state.connected && (
						<div>
							<button
								className={Styles.closeButton}
								onClick={this.deletePod}
							>
								CLOSE
							</button>
						</div>
					)}
					<View>
						<div
							ref={this.screenRef}
							style={{ width: '100%', height: '100%' }}
						/>
					</View>
				</div>
			</div>
		)
	}
}

const mapStateToProps = (
	state: ApplicationState
): { profile: ProfileState; config: ConfigState; channel: ChannelState } => ({
	profile: state.profile,
	config: state.config,
	channel: state.channel,
})

export default connect(mapStateToProps, {
	generateCode,
	wsMessage,
	subscribe,
	wsConnect,
})(Page)
